<template>
   
    <div class="container mt-2 justify-content-center">
     <div class="row ">
   
             <div class="col-12 mt-3">

      
<!-- Button trigger modal -->


<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
       
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        
        <table>
          <tr v-for="student in students" :key="student.students.studentID">
            <td> <p class="text-dark" >{{ student.students.fname }}  {{  student.students.lname }}  </p></td>
            <td> <button type="button" :class="student.evaluations.length>0 && student.evaluations[0].evaluation_typeID==1?'btn btn-success ms-2':'btn btn-outline-success ms-2'" @click="saveevaluation(1,student.registrationID,student.groupN)">დადასტურება</button></td>
            <td><button type="button" :class="student.evaluations.length>0 && student.evaluations[0].evaluation_typeID==0?'btn btn-danger  ms-3':'btn btn-outline-danger  ms-3'" @click="saveevaluation(0,student.registrationID,student.groupN)">არ დადასტურება</button> </td>
          </tr>
        </table>
         
        
      </div>
      
    </div>
  </div>
</div>



<table class="table">
   <thead>
     <tr>
       <th scope="col">#</th>
       <th scope="col">მოდული</th>
       <th scope="col">ლექტორი</th>
       <th scope="col">დღე</th>
       <th scope="col">ლექციის დაწყება</th>
       <th scope="col">ლექციის დასრულება</th>
       <th scope="col">მოდულის დაწყება</th>
       <th scope="col">მოდულის დასრულება</th>
     
      
 
     </tr>
   </thead>
   <tbody>
     
     <tr v-for="group in groups" :key="group.groupID" >
       <th @dblclick="showStudentsEvaluations(group.groupN)" scope="row">{{ group.groupN }}</th>
       <td>{{ group.module_name.module_name }}</td>
       <td>{{ group.person.fname }} {{ group.person.lname }}</td>
       <td>{{ group.day.day }}</td>
       <td>{{ group.lecture_start }}</td>
       <td>{{ group.lecture_end}}</td>
       <td>{{ group.start_date}}</td>
       <td>{{ group.finish_date}}</td>
       <td><button type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop" @click="getStudentsInGroup(group.groupN)" class="btn btn-outline-success"><i class='bx bxs-user-account'></i></button> </td>
       
     </tr>
    
   
   
 
   </tbody>
 </table>
       
    

             </div>
 
     </div>
    </div>
  

 </template>
<script>
import HttpRequests from '../httpRequests/httpRequests';
const httpRequests= new HttpRequests()
export default{
data(){
  return{
    groups:[],
    students:[],

  }
},
mounted(){
    httpRequests.getLecturerGroups().then(response=>{
      this.groups=response.data
    })
  },
  methods:{
    getStudentsInGroup(groupN){

 
httpRequests.getStudentsInGroup(groupN).then(response=>{
  
  this.students=response.data
 
})

},
saveevaluation(evaluation_type,registrationID,groupN){
 httpRequests.saveevaluation(evaluation_type,registrationID).then(()=>{

    this.getStudentsInGroup(groupN)

 })
 
}
  }


}

</script>


